export const imagePath =
  "https://ik.imagekit.io/hg4fpytvry/product-images/tr:w-300,f-webp/";
export const imgKitImagePath =
  "https://ik.imagekit.io/hg4fpytvry/product-images";

export const imageUrl =
  "https://ik.imagekit.io/hg4fpytvry/product-images/";
